import { requestGlobalUserData } from "../../apis";

export const apiPostBindTelegram = (params) =>
  requestGlobalUserData("post", `/user/telegram/bind`, params, true, false);
